import { useMutation } from "@/compat/reactQuery";
import riskAssessmentAttachmentService from "../../services/riskAssessmentAttachmentService";

const useUploadRiskAssessmentAttachments = () =>
    useMutation(riskAssessmentAttachmentService.uploadAttachments);

export default useUploadRiskAssessmentAttachments;
